




















































































import { Component, Vue } from "vue-property-decorator";
import { Constants, Console, Events } from "@/common/global.ts";

import BasePage from "@/common/base-page.ts";
import UIShareModal from "@/views/ui/ShareModal.vue";

@Component({
    components: {
        UIShareModal,
    },
})
export default class Experience extends BasePage {

    /**
     * [name description]
     *
     * @type {[type]}
     */
    public name: string = "page/experience";

    /**
     * [iframeWindow description]
     *
     * @type {[type]}
     */
    private iframeWindow: any;

    /**
     * Delay until the experience fades in
     *
     * @type {Number}
     */
    private experienceDelay: number = 1000 * 0;

    /**
     * Delay until the sliders come in
     *
     * @type {Number}
     */
    private sliderDelay: number = 1000 * 30;
    // private sliderDelay: number = 1000 * 1;

    /**
     *
     */
    public mounted(): void {
        window.orbit.setup("#OrbitApp");
    }

    /**
     *
     */
    public attachEvents(): void {
        window.addEventListener(Events.ANIMATION_COMPLETE, this.Handle_OnAnimationComplete);
        // window.addEventListener(Events.RESIZE, this.Handle_OnResize);
    }

    /**
     *
     */
    public detachEvents(): void {
        window.removeEventListener(Events.ANIMATION_COMPLETE, this.Handle_OnAnimationComplete);
        // window.removeEventListener(Events.RESIZE, this.Handle_OnResize);
    }


    // Animation
    // -----------------------------------------------------------------

    public AnimateIn(onComplete: any = null): void {
        super.AnimateIn(onComplete);

        this.setPageName();

        this.trigger(Events.BACKGROUND_PAUSE, null, true);

        this.Handle_OnAnimationReady();
    }

    public AnimateOut(onComplete: any = null): void {
        // Override the super method
        this.animationClass = "state-animate-out state-show-experience";

        // Enable background movement
        this.trigger(Events.BACKGROUND_PLAY, null, true);

        // Kill anything related to Orbit
        window.orbit.stop();

        // Wait for transition
        setTimeout(onComplete, 4000);
    }


    // Event Handlers
    // -----------------------------------------------------------------

    private Handle_OnAnimationReady(): void {
        // Send message
        window.orbit.play();

        // Animate the experience in
        setTimeout(() => {
            this.setState(Constants.STATE_SHOW_EXPERIENCE);
        }, this.experienceDelay);

        // Animate the controls
        setTimeout(() => {
            if (this.IsAnimatedOut()) {
                this.log("Animated out. Skipping call.");
                return;
            }

            //
            this.setState(Constants.STATE_SHOW_CONTROLS);
        }, this.sliderDelay);
    }

    // private Handle_OnResize() {

    // }

    private Handle_OnAnimationComplete(): void {
        this.$router.push("/share");
    }

    private Handle_OnClickCustomize(e: MouseEvent): void {
        e.preventDefault();

        // enable/disable the sliders
        let shouldDisable = false;

        if ( document.getElementsByClassName("state-customize").length > 0 ){
            shouldDisable = true;
        }

        // cw
        (document.getElementsByName("inputBodyColor")[0] as HTMLInputElement).disabled = shouldDisable;
        (document.getElementsByName("inputStarColor")[0] as HTMLInputElement).disabled = shouldDisable;
        (document.getElementsByName("inputBackground")[0] as HTMLInputElement).disabled = shouldDisable;

        this.toggleState("customize");
    }

    private Handle_OnChangeSlider(e: Event): void {
        const $el: HTMLInputElement = <HTMLInputElement> e.currentTarget;
        const name: string = $el.name;
        const value: number = parseFloat($el.value);

        window.orbit.changeSlider(name, value);

        // this.sendMessage(<ISendMessage> {
        //     event: Events.CONTROL,
        //     data: { name, value },
        // });
    }

    private Handle_OnOpenModal(e: MouseEvent): void {
        e.preventDefault();
        const shareModal: HTMLDivElement = <HTMLDivElement> this.$refs.ShareModal;
        const $el: UIShareModal = <UIShareModal> this.$refs.ShareModal;
        $el.open();
    }

}
